import AccountSettings from './Settings';
import CommunicationsView from './Communications';
import CoachView from "./Coach";
import CoachHeaderView from './Coach/CoachHeader';
import CoachDescriptionView from './Coach/CoachDescription';
import CoachSubscriptionTypeView from './Coach/CoachSubscriptionType';
import CoachFeaturesView from './Coach/CoachFeatures';
import CoachFormTableView from "./Coach/CoachFormTable";

export { AccountSettings };
export { CommunicationsView };
export { CoachView };
export { CoachHeaderView };
export { CoachDescriptionView };
export { CoachSubscriptionTypeView };
export { CoachFeaturesView };
export { CoachFormTableView };